import { Navigate, useParams, useRoutes } from "react-router-dom";
import AccountRoutes from "./account/routes";

import AdminRoutes from "./admin/routes";
import ArticlePage from "./article";
import BillingRoutes from "./billing/routes";
import ContactPage from "./contact";
import ContactCompletePage from "./contact-complete";
import DocsRoutes from "./docs/routes";
import HomePage from "./home";
import LoginPage from "./login";
import LogoutPage from "./logout";

import NotFoundPage from "./not-found";
import ProductPage from "./products";
import SignupPage from "./signup";

export default () =>
  useRoutes([
    { path: "/contact/complete", element: <ContactCompletePage/> },
    { path: "/contact", element: <ContactPage/> },
    { path: "/login", element: <LoginPage/> },
    { path: "/logout", element: <LogoutPage/> },
    { path: "/signup", element: <SignupPage/> },
    { path: "/article/:id", element: <WithParameters component={ArticlePage}/> },
    { path: "/products/:type/:id/:action", element: <WithParameters component={ProductPage}/> },
    { path: "/products/:type/:id", element: <WithParameters component={ProductPage}/> },
    { path: "/products/:type", element: <WithParameters component={ProductPage}/> },
    { path: "/account/*", element: <AccountRoutes/> },
    { path: "/admin/*", element: <AdminRoutes/> },
    { path: "/billing/*", element: <BillingRoutes/> },
    { path: "/docs/*", element: <DocsRoutes/> },
    { path: "/not-found", element: <NotFoundPage/> },
    { path: "/terms.html", element: <ArticlePage id="terms"/> },
    { path: "/terms", element: <ArticlePage id="terms"/> },
    { path: "/*", element: <Navigate replace to="/not-found"/> },
    { path: "/", element: <HomePage/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  return <Comp {...parameters} />;
}
